import PayForTarifBtn from './PayForTarifBtn';
export default PayForTarifBtn;



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarifBtn/index.js